<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择"
      width="800px"
      top="5vh"
  >
    <table-select
        :filter="filter"
        :columns="columns"
        module="basic"
        url="employees"
        @select="selectEmployees"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="员工编号">
            <el-input v-model.trim="filter.employeeNO" placeholder="请输入员工编号" clearable/>
          </el-form-item>
          <el-form-item label="员工名称">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入员工姓名" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {},
        index:0,
        columns: [
          {
            title: "员工编号",
            key: "employeeNO",
            width: 100,
            align: "center",
          },
          {
            title: "员工姓名",
            key: "employeeName",
            width: 100,
            align: "center",
          },
          {
            title: "性别",
            key: "gender",
            width: 70,
            align: "center",
            render: (h, params) => {
              return h("div", [h("strong", params.row.gender ? "女" : "男")]);
            },
          },
          {
            title: "所属部门",
            key: "departmentName",
          },
          {
            title: "职位",
            key: "postName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "left",
          },
        ],
      };
    },
    methods: {
      open(index) {
        this.dialogVisible = true;
        this.index=index;
      },

      selectEmployees(row) {
        this.dialogVisible = false;
        this.$emit("select",this.index,row);
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
